var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-module--loader",style:({
    backgroundColor: 'rgb(' + this.bgColor + ')'
  })},[_c('div',{staticClass:"loader",style:(_vm.cssVars)},[_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span'),_c('span')])])
}
var staticRenderFns = []

export { render, staticRenderFns }